module.exports = __webpack_public_path__ + "static/img/TestRecords.be19796c.svg";